'use strict';

import Backbone from  'backbone';
import config from  '../../../js/config';
import userService from  '../../../services/CartUserService';

var RegionsDropdownView = Backbone.View.extend({

  events: {
    'click a': 'regionDropdownClick'
  },

  regionDropdownClick: function(e) {
    e.preventDefault();

    this.url = config.urls.header.componentsSearchBase;

    var $currentSelection = this.$el.find('[data-value="' + e.target.getAttribute('data-value') + '"]');
    userService.setRegionCookie($currentSelection.attr('data-value'));
    window.location.href = this.url + $currentSelection.attr('data-value');
  }

});

module.exports = RegionsDropdownView;





// WEBPACK FOOTER //
// ./assets/components/Header/js/RegionsDropdownView.js